// Pop-up Maison Elirati Club : s'ouvre après 12 s sur la page ou à 40 % de défilement (le premier des deux), ou à la sortie
// de la souris (ordinateur). Une fois tous les 7 jours au plus, jamais après une inscription ni pour une
// personne déjà connue de Klaviyo. Étape 1 : email seul (liste Klaviyo du club, simple opt-in). Étape 2 : cadeau dévoilé,
// numéro WhatsApp facultatif avec accord explicite et sa date, enregistré sur la fiche de la cliente.
(function () {
  'use strict';

  var root = document.getElementById('ElClubPop');
  if (!root) return;

  var KEY = 'elClubPop';
  var DELAY_MS = 12000;
  var MIN_MS = 0;
  var SCROLL = 0.4;
  var SNOOZE_MS = 7 * 24 * 3600 * 1000;
  var AR = root.getAttribute('data-locale') === 'ar';
  var T = AR
    ? { email: 'أدخلي بريداً إلكترونياً صحيحاً.', phone: 'أدخلي رقم واتساب صحيحاً.', consent: 'يُرجى الموافقة على تلقّي الرسائل على واتساب.', fail: 'تعذّر الإرسال. حاولي مرة أخرى.', sending: 'جارٍ الإرسال…' }
    : { email: 'Enter a valid email address.', phone: 'Enter a valid WhatsApp number.', consent: 'Tick the box to receive WhatsApp messages.', fail: 'Something went wrong. Please try again.', sending: 'Sending…' };

  function read() { try { return JSON.parse(localStorage.getItem(KEY) || '{}'); } catch (e) { return {}; } }
  function write(v) { try { localStorage.setItem(KEY, JSON.stringify(v)); } catch (e) {} }

  var state = read();
  if (state.joined) return;
  if (state.closedAt && Date.now() - state.closedAt < SNOOZE_MS) return;

  var started = Date.now();
  var opened = false;
  var lastFocus = null;
  function show() {
    lastFocus = document.activeElement;
    root.hidden = false;
    document.documentElement.style.overflow = 'hidden';
    var first = root.querySelector('#ElClubEmail');
    if (first) first.focus({ preventScroll: true });
  }
  // Ne s'ouvre pas par-dessus une autre fenêtre, ni pour une personne déjà connue de Klaviyo (clic depuis un email).
  function open() {
    if (opened || document.querySelector('dialog[open]')) return;
    opened = true;
    clearTimeout(timer);
    window.removeEventListener('scroll', onScroll);
    document.removeEventListener('mouseout', onLeave);
    if (window.klaviyo && typeof window.klaviyo.isIdentified === 'function') {
      window.klaviyo.isIdentified().then(function (known) { if (!known) show(); }).catch(show);
    } else show();
  }
  var early = function () { return Date.now() - started < MIN_MS; };
  function onLeave(e) { if (!e.relatedTarget && e.clientY <= 0 && !early()) open(); }
  function onScroll() {
    if (early()) return;
    var h = document.documentElement;
    if ((h.scrollTop + window.innerHeight) / h.scrollHeight >= SCROLL) open();
  }
  function close() {
    root.hidden = true;
    document.documentElement.style.overflow = '';
    if (!read().joined) write({ closedAt: Date.now() });
    if (lastFocus && lastFocus.focus) lastFocus.focus({ preventScroll: true });
  }

  var timer = setTimeout(open, DELAY_MS);
  window.addEventListener('scroll', onScroll, { passive: true });
  if (window.matchMedia && matchMedia('(pointer: fine)').matches) document.addEventListener('mouseout', onLeave);
  root.addEventListener('click', function (e) { if (e.target.closest('[data-ec-close]')) close(); });
  document.addEventListener('keydown', function (e) { if (e.key === 'Escape' && !root.hidden) close(); });

  // Inscription Klaviyo (API client publique). `extra` : propriétés et numéro ajoutés à la fiche.
  function subscribe(email, extra) {
    var attributes = { email: email, properties: Object.assign({ signup_source: 'maison_club_popup', signup_locale: AR ? 'ar' : 'en' }, extra && extra.properties), subscriptions: { email: { marketing: { consent: 'SUBSCRIBED' } } } };
    if (extra && extra.phone) attributes.phone_number = extra.phone;
    return fetch('https://a.klaviyo.com/client/subscriptions/?company_id=' + encodeURIComponent(root.getAttribute('data-public-key')), {
      method: 'POST',
      headers: { revision: '2025-04-15', 'Content-Type': 'application/vnd.api+json', Accept: 'application/vnd.api+json' },
      body: JSON.stringify({
        data: {
          type: 'subscription',
          attributes: { custom_source: 'Maison Elirati Club popup', profile: { data: { type: 'profile', attributes: attributes } } },
          relationships: { list: { data: { type: 'list', id: root.getAttribute('data-list-id') } } },
        },
      }),
    }).then(function (res) {
      if (res.status >= 200 && res.status < 300) return true;
      throw new Error('Klaviyo ' + res.status);
    });
  }

  function busy(button, on, label) {
    button.disabled = on;
    if (on) { button.dataset.label = button.textContent; button.textContent = T.sending; }
    else button.textContent = label || button.dataset.label;
  }
  function err(el, msg) { el.textContent = msg; el.hidden = !msg; }

  // Étape 1 : email seul.
  var form = root.querySelector('[data-ec-form]');
  var errorEl = root.querySelector('[data-ec-error]');
  var submit = root.querySelector('[data-ec-submit]');
  var joinedEmail = '';
  form.addEventListener('submit', function (e) {
    e.preventDefault();
    err(errorEl, '');
    var email = form.email.value.trim().toLowerCase();
    if (!/^[^\s@]+@[^\s@]+\.[^\s@]{2,}$/.test(email)) { err(errorEl, T.email); form.email.focus(); return; }
    busy(submit, true);
    subscribe(email)
      .then(function () {
        joinedEmail = email;
        write({ joined: true });
        try { if (window.klaviyo) window.klaviyo.identify({ email: email }); } catch (x) {}
        root.querySelector('[data-ec-step="form"]').hidden = true;
        root.querySelector('[data-ec-step="done"]').hidden = false;
      })
      .catch(function () { err(errorEl, T.fail); busy(submit, false); });
  });

  // Numéro national → format international (sans le 0 de tête), ex. 050 123 4567 + 971 → +971501234567
  function e164(cc, raw) {
    var digits = String(raw || '').replace(/\D/g, '').replace(/^00/, '');
    if (digits.indexOf(cc) === 0 && digits.length > cc.length + 6) digits = digits.slice(cc.length);
    digits = digits.replace(/^0+/, '');
    return digits.length >= 7 && digits.length <= 10 ? '+' + cc + digits : null;
  }

  // Étape 2 (facultative) : numéro WhatsApp avec accord explicite.
  var wa = root.querySelector('[data-ec-wa]');
  var waError = root.querySelector('[data-ec-wa-error]');
  var waSubmit = root.querySelector('[data-ec-wa-submit]');
  wa.addEventListener('submit', function (e) {
    e.preventDefault();
    err(waError, '');
    var phone = e164(wa.cc.value, wa.phone.value);
    if (!phone) { err(waError, T.phone); wa.phone.focus(); return; }
    if (!wa.consent.checked) { err(waError, T.consent); wa.consent.focus(); return; }
    busy(waSubmit, true);
    var properties = { whatsapp_number: phone, whatsapp_consent: true, whatsapp_consent_at: new Date().toISOString() };
    // Si Klaviyo refuse le numéro au format SMS, on réessaie sans : il reste enregistré dans whatsapp_number.
    subscribe(joinedEmail, { phone: phone, properties: properties })
      .catch(function () { return subscribe(joinedEmail, { properties: properties }); })
      .then(function () {
        wa.hidden = true;
        root.querySelector('[data-ec-wa-done]').hidden = false;
      })
      .catch(function () { err(waError, T.fail); busy(waSubmit, false); });
  });
})();
